import { ActionContext, ActionTree, GetterTree } from "vuex";
import { ShakenShohiyou, ShatenExtensionPivotVO } from "@/model/shakenShoHiyou";
import { HouteiHiyouSave } from "@/model/CustomerSave";
import { HouteiHiyou } from "@/model/shakenShohiyou";
import { KensaHiyou, ShakenHiyou } from '../../model/shakenShohiyou';

const initialState: ShakenShohiyou = {
  houteiHiyou: {} as HouteiHiyou,
  kensaHiyou: {} as KensaHiyou,
  shakenHiyou: {} as ShakenHiyou,
  totalZn: 0,
  totalZk: 0,
  isHikazei: 0,
  isConfirm: 0,
  /** 2023-10-19 invoice [START] */
  subTotalHikazei: 0,
  subTotalKazei: 0,
  /** 2023-10-19 invoice [END] */
  shatenExtensionPivotVO: {} as ShatenExtensionPivotVO
};
const actions: ActionTree<ShakenShohiyou, any> = {
  setShakenShohiyou(
    { commit }: ActionContext<ShakenShohiyou, any>,
    payload: ShakenShohiyou
  ): void {
    commit("setShakenShohiyou", payload);
  },
  confirm(
    { commit }: ActionContext<ShakenShohiyou, any>,
    payload: number
  ): void {
    commit("confirm", payload);
  },
  updateTax(
    { commit }: ActionContext<ShakenShohiyou, any>,
    payload: any
  ): void {
    commit("updateTax", payload);
  },
  updateShakenHiyou(
    { commit }: ActionContext<ShakenShohiyou, any>,
    payload: any
  ): void {
    commit("updateShakenHiyou", payload);
  },
  clearState({ commit }: ActionContext<ShakenShohiyou, any>): void {
    commit("clearState");
  },
  updateKensaHiyou(
    { commit }: ActionContext<ShakenShohiyou, any>,
    payload: any
  ): void {
    commit("updateKensaHiyou", payload);
  }
};

const mutations = {
  setShakenShohiyou(state: ShakenShohiyou, payload: ShakenShohiyou) {
    Object.assign(state, payload);
    calTotal(state, state.houteiHiyou);
  },
  confirm(state: ShakenShohiyou, payload: number) {
    state.isConfirm = payload;
  },
  updateTax(
    state: ShakenShohiyou,
    payload: {
      zeiWeightTax: number;
      zkWeightTaxCd: string;
      zeiJibaisekiZk: number;
      zeiJibaisekiZn: number;
      zkJibaisekiCd: string;
      zeiJibaisekiMonthCnt: number;
      zeiInshidaiZn: number;
      zeiInshidaiZk: number;
      ryoukinRankCd: string;
      isMadoguchiInshidai: number;
      isUseTechInfoAmount: number;
      zeiTechInfoAmountZn: number;
      zeiTechInfoAmountZk: number;
    }
  ) {
    const houteiHiyou = state.houteiHiyou;
    if (houteiHiyou) {
      houteiHiyou.zeiWeightTax = payload.zeiWeightTax;
      houteiHiyou.weightTaxCd = payload.zkWeightTaxCd;
      houteiHiyou.zeiJibaisekiZk = payload.zeiJibaisekiZk;
      houteiHiyou.zeiJibaisekiZn = payload.zeiJibaisekiZn;
      houteiHiyou.zeiJibaisekiMonthCnt = payload.zeiJibaisekiMonthCnt;
      houteiHiyou.jibaisekiCd = payload.zkJibaisekiCd;
      houteiHiyou.zeiInshidaiZk = payload.zeiInshidaiZk;
      houteiHiyou.zeiInshidaiZn = payload.zeiInshidaiZn;
      houteiHiyou.ryoukinRankCd = payload.ryoukinRankCd ? payload.ryoukinRankCd : null;
      houteiHiyou.isMadoguchiInshidai = payload.isMadoguchiInshidai;
      calTotal(state, houteiHiyou);
    }
  },
  updateShakenHiyou(state: ShakenShohiyou, payload: any) {
    if (payload.shakenHiyous) {
      state.shakenHiyou.items = payload.shakenHiyous;
      state.shakenHiyou.subTotalZk = state.shakenHiyou.items.reduce((acc, cur) => {
        if (cur.shohiyouNm) {
          return acc + (cur.kingakuZk || 0);
        }
        return acc;
      }, 0);
      state.shakenHiyou.subTotalZn = state.shakenHiyou.items.reduce((acc, cur) => {
        if (cur.shohiyouNm) {
          return acc + (cur.kingakuZn || 0);
        }
        return acc;
      }, 0);
      calTotal(state, state.houteiHiyou);
    }
  },
  clearState(state: ShakenShohiyou) {
    Object.assign(state, { ...initialState });
  },
  updateKensaHiyou(state: ShakenShohiyou, payload: ShakenShohiyou) {
    Object.assign(state.kensaHiyou, payload.kensaHiyou);
    calTotal(state, state.houteiHiyou);
  }
};

const getters: GetterTree<ShakenShohiyou, any> = {
  hasData(state: ShakenShohiyou) {
    if (state.houteiHiyou && Object.keys(state.houteiHiyou).length > 0) {
      return true;
    }
    return false;
  },
  currentState(state: ShakenShohiyou) {
    return state;
  },
  total(state: ShakenShohiyou) {
    const { totalZn, totalZk, isHikazei, isConfirm } = state;
    return { totalZn, totalZk, isHikazei, isConfirm };
  },
  /** 2023-10-19 invoice [START] */
  shohiyouZn(state: ShakenShohiyou) {
    const { subTotalHikazei, subTotalKazei } = state;
    return { subTotalHikazei, subTotalKazei };
  },
  /** 2023-10-19 invoice [END] */
  isConfirm(state: ShakenShohiyou) {
    return state.isConfirm;
  },
  dataForSavePayment(state: ShakenShohiyou) {
    if (state.houteiHiyou && Object.keys(state.houteiHiyou).length > 0) {
      let houteiHiyou = { ...state.houteiHiyou };
      let houteiHiyouSave: HouteiHiyouSave = {
        zeiWeightTax: houteiHiyou.zeiWeightTax,
        zeiWeightTaxText: houteiHiyou.zeiWeightTaxText,
        zeiJibaisekiMonthCnt: houteiHiyou.zeiJibaisekiMonthCnt,
        zeiJibaisekiZn: houteiHiyou.zeiJibaisekiZn,
        zeiJibaisekiZk: houteiHiyou.zeiJibaisekiZk,
        zeiInshidaiZn: houteiHiyou.zeiInshidaiZn,
        zeiInshidaiZk: houteiHiyou.zeiInshidaiZk,
        ryoukinRankCd: houteiHiyou.ryoukinRankCd ? houteiHiyou.ryoukinRankCd : null,
        subTotalZn: houteiHiyou.subTotalZn,
        subTotalZk: houteiHiyou.subTotalZk,
        weightTaxCd: houteiHiyou.weightTaxCd,
        jibaisekiCd: houteiHiyou.jibaisekiCd,
        isHikazei: 0
      };
      let obj: any = { ...state };
      obj.houteiHiyou = houteiHiyouSave;
      return obj;
    }
    return state;
  }
};

function calTotal(state: ShakenShohiyou, houteiHiyou: HouteiHiyou) {
  houteiHiyou.subTotalZk =
    houteiHiyou.zeiInshidaiZk +
    houteiHiyou.zeiWeightTax +
    houteiHiyou.zeiJibaisekiZk + (houteiHiyou.isUseTechInfoAmount == 1 && houteiHiyou.zeiTechInfoAmountZk ? houteiHiyou.zeiTechInfoAmountZk : 0);
  houteiHiyou.subTotalZn =
    houteiHiyou.zeiInshidaiZn +
    houteiHiyou.zeiWeightTax +
    houteiHiyou.zeiJibaisekiZn + (houteiHiyou.isUseTechInfoAmount == 1 && houteiHiyou.zeiTechInfoAmountZn ? houteiHiyou.zeiTechInfoAmountZn : 0);

  if (state.kensaHiyou.subTotalZk == null) {
    state.kensaHiyou.subTotalZk = 0;
  }
  if (state.kensaHiyou.subTotalZn == null) {
    state.kensaHiyou.subTotalZn = 0;
  }
  state.totalZk =
    houteiHiyou.subTotalZk +
    state.kensaHiyou.subTotalZk +
    state.shakenHiyou.subTotalZk;
  state.totalZn =
    houteiHiyou.subTotalZn +
    state.kensaHiyou.subTotalZn +
    state.shakenHiyou.subTotalZn;
  /** 2023-10-19 invoice [START] */
  /** 2023-10-23 disp uchizei (invoice part 8) [START] */
  state.subTotalHikazei = houteiHiyou.subTotalZn
  //+ (state.kensaHiyou.isHikazei == 1 && state.kensaHiyou.subTotalZn ? state.kensaHiyou.subTotalZn : 0);
  //+ (state.shakenHiyou.isHikazei == 1 && state.shakenHiyou.subTotalZn ? state.shakenHiyou.subTotalZn : 0);
  + 0;
  houteiHiyou.subTotalZn;
  state.subTotalKazei = 
  //+ (state.kensaHiyou.isHikazei == 1 && state.kensaHiyou.subTotalZn ? state.kensaHiyou.subTotalZn : 0);
  //+ (state.shakenHiyou.isHikazei == 1 && state.shakenHiyou.subTotalZn ? state.shakenHiyou.subTotalZn : 0);
  + state.kensaHiyou.subTotalZn
  + state.shakenHiyou.subTotalZn
  + 0;
  /** 2023-10-23 disp uchizei (invoice part 8) [END] */
  /** 2023-10-19 invoice [END] */
}

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
